import {
  composeGenericAppContextValue,
  GenericAppContextProvider,
  type GenericAppContextValue,
} from '@repo/internal-tools-app-lib/src/lib/GenericAppContext/GenericAppContext.tsx'
import { createContext, type ReactNode, useMemo } from 'react'
import {
  ENV_CCC_QUEUE_BASE_PATH,
  ENV_INTERNAL_BFF_URL,
  ENV_INTERNAL_SIGNALR_URL,
} from '../../env.ts'

export type QueueAppSpecificContextValue = {
  baseSignalrUrl: string
}

export interface QueueAppContextValue
  extends GenericAppContextValue,
    QueueAppSpecificContextValue {}

// eslint-disable-next-line react-refresh/only-export-components
export const QueueAppContext = createContext<
  QueueAppSpecificContextValue | undefined
>(undefined)

export type QueueAppContextProviderProps = Partial<QueueAppContextValue> & {
  children?: ReactNode
}

export const QueueAppContextProvider = (
  props: QueueAppContextProviderProps,
) => {
  const { children, baseSignalrUrl, ...genericContextProps } = props

  const queueAppSpecificContextValue = useMemo(
    () => ({ baseSignalrUrl: baseSignalrUrl ?? ENV_INTERNAL_SIGNALR_URL }),
    [baseSignalrUrl],
  )

  // Memoize value depending on each value instead of the object reference.
  const genericContextValue = useMemo(
    () =>
      composeGenericAppContextValue({
        input: genericContextProps,
        defaultValues: {
          basePath: ENV_CCC_QUEUE_BASE_PATH,
          baseApiUrl: ENV_INTERNAL_BFF_URL,
        },
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(genericContextProps),
  )

  return (
    <GenericAppContextProvider {...genericContextValue}>
      <QueueAppContext.Provider value={queueAppSpecificContextValue}>
        {children}
      </QueueAppContext.Provider>
    </GenericAppContextProvider>
  )
}
